<div class="dialog">
  @if (isMobileView) {
    <header class="mobile-app-bar">
      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'Select Event Dates' | translate }}</h2>
      <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Save</p>
    </header>
  } @else {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Select Event Dates' | translate }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px', cursor: 'pointer' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }
  <div class="dialog__content">
    <div class="event-dates-selection">
      <div class="event-info mb-20">
        <h4 class="event-name">{{ event.name }}</h4>
        <p class="event-description" translate>Select the dates you want to join for this event</p>
      </div>

      <form [formGroup]="form">
        <div class="dates-selection-container">
          <div class="selection-actions mb-16">
            <button (click)="selectAll()" class="button button-outline-primary mr-8" translate type="button">Select all</button>
            <button (click)="selectNone()" class="button button-simple" translate type="button">Clear All</button>
          </div>

          <div class="dates-grid" formArrayName="selectedDates">
            @if (availableDates.length > 0) {
              @for (dateRange of availableDates; track dateRange.dateFrom + dateRange.dateEnd; let i = $index) {
                <div class="card date-card" [class.selected]="selectedDatesArray.at(i).value" [class.already-selected]="isUserAlreadyJoinedForDateRange(dateRange)" (click)="toggleDate(i)">
                  <div class="date-card-content">
                    <div class="date-card-left">
                      <div class="date-header">
                        <app-icon color="var(--text-color-dark)" iconName="calendar" size="18px"></app-icon>
                        <span class="date-text">{{ formatDateDisplay(dateRange) }}</span>
                      </div>
                      <div class="time-row">
                        <app-icon iconName="clock" size="15px"></app-icon>
                        <span class="time-text">
                          {{ getEventTimeForDateRange(dateRange)?.startTime }} - {{ getEventTimeForDateRange(dateRange)?.endTime }}
                          <span translate>Clock</span>
                        </span>
                      </div>
                    </div>
                    <div class="checkbox-wrapper">
                      <input class="checkbox" [formControlName]="i" [id]="'date-' + i" type="checkbox" (click)="$event.stopPropagation()" />
                    </div>
                    @if (isUserAlreadyJoinedForDateRange(dateRange)) {
                      <div class="already-joined-badge">
                        <span translate>courses.joined</span>
                      </div>
                    }
                  </div>
                </div>
              }
            } @else {
              <div class="no-dates" translate>No available dates for this event</div>
            }
          </div>

          @if (hasSelectedDates()) {
            <div class="selected-info mt-16">
              <p class="selected-count">
                {{ 'Selected' | translate }}: <strong>{{ getSelectedDates().length }}</strong>
                {{ (getSelectedDates().length === 1 ? 'date' : 'dates') | translate }}
                @if (hasNewlySelectedDates()) {
                  <span class="newly-selected-info"> ({{ getNewlySelectedDates().length }} {{ 'new' | translate }}) </span>
                }
              </p>
            </div>
          }
        </div>
      </form>
    </div>
  </div>

  <footer class="dialog__footer">
    <div class="dialog__footer__buttons">
      <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
      <app-button (clickEvent)="join($event)" [disabled]="!hasNewlySelectedDates()" [idleText]="'Join Selected Dates' | translate" cssClass="button-primary"></app-button>
    </div>
  </footer>
</div>
